import { render } from "./Show.vue?vue&type=template&id=348d746c"
import script from "./Show.vue?vue&type=script&setup=true&lang=js"
export * from "./Show.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Profile/Show.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "348d746c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('348d746c', __exports__)) {
    api.reload('348d746c', __exports__)
  }
  
  module.hot.accept("./Show.vue?vue&type=template&id=348d746c", () => {
    api.rerender('348d746c', render)
  })

}


export default __exports__